<script>
import PInput from "./p-input.vue";
import PTextarea from "./p-textarea.vue";
import PSelect from "./p-select.vue";
import PCard from "./p-card.vue";
import clientService from "../services/clients.js";
import { validate } from "../utils/";
import notificationService from "../plugins/notify";
import getConstants from "../services/getConstants";

export default {
    name: "p-client-register",
    props: ['type'],
    components: {
        PInput,
        PSelect,
        PCard,
        PTextarea
    },
    data() {
        return {
            form: {},
            errors: {},
            success: false,
            submitDisabled: false,
            textSaveButtom: ''
        };
    },
    methods: {
        submit(e) {
            this.submitDisabled = true;
            this.errors = validate(e);
            if (!!Object.keys(this.errors).length) {
                this.submitDisabled = false;
                return
            }
            clientService[this.type](this.form).then( response => {
                this.notify(
                    'success',
                    'Aguarde ser redirecionado para página inicial.',
                    'Cliente salvo! :)'
                );
                    this.success = true;
                    this.reset(e);
                    setTimeout(function(){
                        window.location.href = '/index.php#' + response.data.message;
                    }, 3000);
                    this.success = false;
                    this.reset(e);
            },err => {
                this.notify('error', getConstants(err.data.message), `Não foi possível ${this.textSaveButtom}!`);
                this.reset(e);
                console.log(err);
            });
        },
        reset(form) {
            form.target.reset();
            this.errors = [];
            this.submitDisabled = false;
        },
        notify(type, message, title)  {
            new notificationService()
            .type(type)
            .message(message)
            .title(title)
            .notify()
        },
        setupUpdate() {
            this.textSaveButtom = 'Salvar'
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            let _id = params.get("id");
            clientService.get(_id).then(res => {
                this.form = {
                    id          : _id,
                    name        : res.data.nome,
                    cpf         : res.data.cpf,
                    rg          : res.data.rg,
                    dob         : res.data.dtNascimento,
                    gender      : res.data.sexo,
                    phone       : res.data.fone1,
                    celphone    : res.data.fone2,
                    email       : res.data.email,
                    observacao  : res.data.observacao

                }
            }).catch(err => {
                console.log(err);
            })  
        },
        setupCreate() {
            this.textSaveButtom = 'Cadastrar'
        }
    },
    created: function() {
        if(this.type === 'update'){
            return this.setupUpdate();
        }
        return this.setupCreate();
    }
};
</script>
<template>
<div class="wrapper">

    <p-card>
        <form action="" @submit.prevent="submit" class="p-form" novalidate>
            <div class="fields">
                <div class="form-inline">
                    <p-input name="name" required="true" minlength="3" label="Nome" type="text" :error="errors['name']" v-model="form.name"></p-input>
                </div>

                <div class="form-inline">
                    <p-input name="cpf" mask="###.###.###-##" label="CPF" type="text" :error="errors['cpf']" v-model="form.cpf"></p-input>
                    <p-input name="rg" mask="##########" label="RG" type="text" :error="errors['rg']" v-model="form.rg"></p-input>
                </div>

                <div class="form-inline">
                    <p-input name="dob" required="true" mask="##/##/####" label="Data de Nascimento" type="text" :error="errors['dob']" v-model="form.dob"></p-input>
                    <p-select name="gender" type="gender" label="Sexo" :error="errors['gender']" v-model="form.gender"></p-select>
                </div>

                <div class="form-inline">
                    <p-input name="phone" mask="(##) ####-####" label="Telefone" type="tel" :error="errors['phone']" v-model="form.phone"></p-input>
                    <p-input name="celphone" mask="(##) #####-#####" label="Celular" type="tel" :error="errors['celphone']" v-model="form.celphone"></p-input>
                    <p-input name="email" validate="email" label="Email" type="text" :error="errors['email']" v-model="form.email"></p-input>
                </div>
                <div class="form-inline">
                    <p-textarea name="observacao" label="Observação" :error="errors['observacao']" v-model="form.observacao" rows="3"></p-textarea>
                </div>
            </div>
            <div class="footer pt-2 pb-2 d-flex justify-content-end align-items-center">
                <a href="/" class="btn btn-primary" name="button" title="Voltar" style="margin-right : 8px"><span class="text">Voltar</span></a>
                <button type="submit" :disabled="submitDisabled" class="btn btn-primary" name="button" title="Cadastrar"><span class="text">{{textSaveButtom}}</span></button>
            </div>
        </form>
    </p-card>
</div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/p-client-form.vue